// extracted by mini-css-extract-plugin
export default {"root":"n8agEyGDcDKN1ojKx913","container":"SM3V5ryEKHgGWcMMXD2k"};